<div class="main-container">
    <div class="header-container">
        <p *ngIf="supplierBank?.BankName" i18n="@@58181035684a6d14eb1425dc344ab578605fbf94" t="58181035684a6d14eb1425dc344ab578605fbf94">Edit Bank</p>
        <p *ngIf="!supplierBank?.BankName" i18n="@@AddBank" t="AddBank">Add Bank</p>
    </div>
    <bank-edit #bankEdit class="bank-edit" [tsl-supplierBank]="supplierBank" [tsl-readOnly]="readOnly" [tsl-legalName]="legalName"
      [tsl-generalSettings]="generalSettings$ | async" [tsl-countries]="countries$ | async"
      [tsl-paymentOrigins]="paymentOrigins$ | async" [tsl-intermediaryPaymentOrigins]="intermediaryPaymentOrigins$ | async"
      [tsl-currencies]="currencies$ | async" [tsl-bankConfiguration]="bankConfig$ | async" [tsl-hideCancelButton]="true"
      [tsl-hideSaveButton]="true" [tsl-supplierBankDocType]="requiredDocuments?.DocumentType"
      [tsl-hideDocumentSection]="requiredDocuments == null" [tsl-supplierCode]="supplierCode"
      [tsl-showPaymentOriginControl]="showPaymentOriginControl"
      (tsl-stepChanged)="setErrorMessage(null)" (tsl-onCountryChange)="countryChangeEventHandler($event)"
      (tsl-onVerify)="verifyEventHandler($event.supplierBank)"
      (tsl-onSubmit)="submitEventHandler($event.supplierBank, $event.uploadFiles, $event.isPartialSave, $event.isBankDataChanged)"
      (tsl-onSave)="saveEventHandler($event.supplierBank)" (tsl-onSaveError)="setErrorMessage($event.errorMessage)"
      [tsl-isSupplierTask]="false" [tsl-disableSensitiveFieldModification]="disableSensitiveFieldModification == true" 
      (tsl-onPaymentOriginChange)="onPaymentOriginChangedEvent($event)"
      [tsl-enableDocumentSectionValidationBasedOnFieldModification]= "true"
      [tsl-requiredDocuments]="requiredDocuments"
      [tsl-supplierRequestType]="requestType">
    </bank-edit>
    <div class="button-container">
        <button class="action-btn" tsl-button size="small" color="black" unfilled (click)="onClose()"
            i18n="@@Cancel" t="Cancel">Cancel</button>
        <button *ngIf="!readOnly" class="action-btn" tsl-button size="small" color="blue" filled (click)="onSubmit()"
            i18n="@@Submit" t="Submit">Submit</button>
    </div>
</div>